'use client';

import { motion } from 'motion/react';
import Image from 'next/image';

export default function Performance() {
  return (
    <section className="bg-[#0a0a0a] py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12 text-center text-3xl font-black tracking-tight text-white md:text-4xl"
        >
          BUILT FOR PROFESSIONAL PERFORMANCE
        </motion.h2>

        <div className="grid gap-6 md:grid-cols-3">
          {/* Player Profile Card */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex flex-col overflow-hidden rounded-2xl border border-zinc-800 bg-[#141414] md:col-span-1"
          >
            <div className="relative h-48 w-full">
              <Image
                src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=500&auto=format&fit=crop"
                alt="Player"
                fill
                className="object-cover grayscale"
                referrerPolicy="no-referrer"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#141414] to-transparent" />
              <div className="absolute bottom-4 left-4 rounded bg-[#b4ff00] px-2 py-1 text-[10px] font-bold text-black">
                MVP '24
              </div>
            </div>
            <div className="p-6">
              <div className="mb-1 text-[10px] font-bold tracking-widest text-zinc-500">MIDFIELDER • AJAX ACADEMY</div>
              <h3 className="mb-6 text-xl font-black text-white">MARCUS STERLING</h3>
              
              <div className="grid grid-cols-3 gap-4 border-t border-zinc-800/50 pt-4">
                <div className="text-center">
                  <div className="text-[10px] font-bold text-zinc-500">Match</div>
                  <div className="text-lg font-bold text-white">142</div>
                </div>
                <div className="text-center">
                  <div className="text-[10px] font-bold text-zinc-500">Goals</div>
                  <div className="text-lg font-bold text-white">Top 5</div>
                </div>
                <div className="text-center">
                  <div className="text-[10px] font-bold text-zinc-500">XP</div>
                  <div className="text-lg font-bold text-white">8.2k</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Live Match Card */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col justify-between rounded-2xl border border-zinc-800 bg-[#141414] p-8 md:col-span-2"
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="mb-2 flex items-center gap-2 text-[10px] font-bold text-red-500">
                  <div className="h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" />
                  LIVE MATCH
                </div>
                <h3 className="text-2xl font-black tracking-tight text-white">GRAND FINALS: PARIS MASTERS</h3>
              </div>
              <div className="text-right">
                <div className="text-[10px] font-bold text-zinc-500">VIEWERS</div>
                <div className="text-xl font-bold text-white">24.5K</div>
              </div>
            </div>

            <div className="my-12 flex items-center justify-center gap-8 md:gap-16">
              <div className="flex flex-col items-center gap-4">
                <div className="flex h-12 w-12 md:h-16 md:w-16 items-center justify-center rounded-xl border border-zinc-700 bg-zinc-800 text-xl md:text-2xl font-black text-white">L</div>
                <div className="text-[10px] font-bold tracking-widest text-zinc-400">LIONS FC</div>
              </div>
              
              <div className="flex items-center gap-4 text-2xl md:text-5xl font-black">
                <span className="text-white">2</span>
                <span className="text-zinc-600">:</span>
                <span className="text-[#b4ff00]">3</span>
              </div>

              <div className="flex flex-col items-center gap-4">
                <div className="flex h-12 w-12 md:h-16 md:w-16 items-center justify-center rounded-xl border-2 border-[#b4ff00] bg-[#b4ff00]/10 text-xl md:text-2xl font-black text-[#b4ff00]">B</div>
                <div className="text-[10px] font-bold tracking-widest text-[#b4ff00]">BERLIN UTD</div>
              </div>
            </div>

            <div className="flex justify-center">
              <button className="rounded-sm border border-zinc-700 bg-zinc-800 px-8 py-3 text-xs font-bold text-white transition-colors hover:bg-zinc-700">
                WATCH LIVE STREAM
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
